import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  FormControl,
  Select,
  MenuItem,
  TablePagination,
  Tooltip,
  Input,
} from "@material-ui/core/";
import moment from "moment";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
// import DownloadIcon from '@mui/icons-material/Download';
import { useSelector, useDispatch } from "react-redux";
import { updatePrice } from "../../../reduxSlices/selectClassSlice";

import { isObjectEmpty } from "../../../utils/general";
import {
  clearLoginData,
  isLoggedInUpdate,
} from "../../../reduxSlices/loginSlice";
import Backdrop from "../../Backdrop";
import Aux from "../../../hoc/Auxilliary";
import MessageIndicator from "../../SnackBar";
import localizedStrings from "../../../utils/localize";

import {
  getOptionList,
  getDocuments,
} from "../../../reduxSlices/applicationSlice";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },

  formControl: {
    color: "white",
    fontSize: "0.875rem",
  },
});

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

function PageConatiner(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [tableMapData, setTableMapData] = useState([]);
  const [displayMessage,setDisplayMessage]=useState('')
 
  const dataFetchingStatus = useSelector(
    (state) => state.applicationData.dataFetchingStatus
  );

  const documents = useSelector((state) => state.applicationData.documents);

  const errorMessage = useSelector(
    (state) => state.applicationData.errorMessage
  );

  const errorStatusCode = useSelector(
    (state) => state.applicationData.errorStatusCode
  );

  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    props.history.push("/login");
  };

  useEffect(() => {
    if (!isObjectEmpty(documents)) {
      const documentsList = [...documents];
      const removeEmptyObjmodalData = documentsList?.filter(
        (value) => Object.keys(value).length !== 0
      );
      // setTableMapData(removeEmptyObjmodalData);

      setTableMapData(
        removeEmptyObjmodalData?.sort(
          (item1, item2) =>
            new Date(item2?.ses_expireddate) - new Date(item1?.ses_expireddate)
        )
      );
    }
  }, [documents]);

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: `${localizedStrings.general.sessionexpired}`,
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);

  const handleClick = (e) => {
    e.preventDefault();

    props.history.push({
      pathname: "/students/select-class/checkout",
    });
  };

  const funcDownloadlink = (documentBody, filename) => {
    var dataType;
    var fileTypes = {
      docx: "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,",
      pdf: "data:application/pdf;base64,",
      jpg: "data:image/jpeg;base64,",
      jpeg: "data:image/jpeg;base64,",
      png: "data:image/png;base64,",
      xlsx: "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,",
      txt: "data:text/plain;base64,",
      xml: "data:application/xml;base64,",
      zip: "data:application/zip;base64,",
      yml: "data:text/yaml;base64,",
      zir: "data:application/vnd.zul;base64,",
    };
    var filetype = filename?.split(".")[1];
   
    for (const sec in fileTypes) {
      if (sec === filetype) {
        dataType = fileTypes[sec];
      }
    }

    return dataType + documentBody;
  };

  useEffect(() => {
    let entity = "ses_course";
    let attributename = "ses_courselevel";
    dispatch(getOptionList(entity, attributename));
    dispatch(getDocuments());
  }, [dispatch]);


  let tableData = "";

  if (!isObjectEmpty(documents)) {
    if (documents) {
      if (Array.isArray(documents)) {
        tableData =
          tableMapData?.length > 0
            ? tableMapData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((element, index) => {
                  return (
                    <StyledTableRow key={index}>
                      <StyledTableCell component="th" scope="row">
                        <a
                          href={funcDownloadlink(
                            element.documentBody,
                            element.filename
                          )}
                          download={element.filename}
                          id={element.filename}
                        >
                          {" "}
                          <i
                            className="fa fa-download"
                            aria-hidden="true"
                            style={{ color: "red", cursor: "pointer" }}
                          ></i>{" "}
                        </a>
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row">
                        {element.ses_document === undefined ? "" : element.ses_document}
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row">
                        {element.filename === undefined
                          ? ""
                          : element?.filename}
                      </StyledTableCell>

                      <StyledTableCell>
                        {element?.ses_description === undefined
                          ? ""
                          : element?.ses_description}
                      </StyledTableCell>
                      <StyledTableCell>
                        {element.ses_expireddate === undefined
                          ? ""
                          : element.ses_expireddate}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })
            : null;
      }
    }
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  useEffect(() => {
    if (error.message === 'Error No documents Found') {
      setDisplayMessage(localizedStrings.general.documentserrorMessage);
    }
    else if (error.message === 'Invalid token') {
      setDisplayMessage(localizedStrings.general.invalidToken);
    }
    else if (error.message === 'Something Went Wrong') {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    }
    else{
      setDisplayMessage(error.message);
    }
  }, [error]);

   // Custom label for the "of" keyword in TablePagination
   const customLabelDisplayedRows = ({ from, to, count }) => {
    return `${from}-${to} ${localizedStrings.general.of} ${count}`;
  };
  
  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={displayMessage}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <TableContainer
        component={Paper}
        style={{ minHeight: "40vh", marginBottom: "10px" }}
      >
        <Table aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell className={classes.formRoot}></StyledTableCell>
              <StyledTableCell className={classes.formRoot}>
              {localizedStrings.documents.subject}
              </StyledTableCell>
              <StyledTableCell>{localizedStrings.documents.filename}</StyledTableCell>
              <StyledTableCell>Description</StyledTableCell>
              <StyledTableCell>{localizedStrings.documents.availableuntil}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>{tableData}</TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={tableMapData?.length > 0 ? tableMapData?.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          labelRowsPerPage={<span style={{textTransform:"none"}}>{localizedStrings.rows.rowsperpage}</span>}
          labelDisplayedRows={customLabelDisplayedRows}
        />
      </TableContainer>
     
    </Aux>
  );
}

export default withRouter(PageConatiner);
